module.exports = __webpack_public_path__ + "static/media/LandingPage.ea48361f.png";